<template>
  <slot>
    <div>
      <div class="flex flex-col items-center mt-7 mx-4">
        <div class="flex items-center">
          <span class="text-5xl font-bold mx-2 tracking-wide">
            {{ title }}
          </span>
        </div>
        <slot name="tagline">
          <div class="mt-2">
            <span class="text-2xl"> {{ tagline }} </span>
          </div>
        </slot>
      </div>
    </div>
  </slot>
</template>

<script setup lang="ts">
import { useTitle } from '@vueuse/core'

const props = withDefaults(
  defineProps<{
    title: string
    tagline?: string
    skipPageTitle?: boolean
  }>(),
  {
    tagline: undefined,
    skipPageTitle: false,
  },
)

if (!props.skipPageTitle) {
  useTitle(`${props.title} - X Pro Targeting`)
}
</script>
